<template>
  <div id="editor">
    <EditorHeader></EditorHeader>

    <div class="container flex justify-start">
      <div class="container__editor">
        <div class="title-wrapper">
          <el-input
            :value="posterTitle"
            class="poster-input"
            placeholder="输入自定义标题"
            @blur="onTitleBlur"
            @input="onTitleChange"
          >
          </el-input>
        </div>
        <EditorContent
          ref="Editor"
          class="editor-component"
        ></EditorContent>
      </div>

      <div class="container__template">
        <div class="template__posters">
          <Poster @refreshImageStatus="refreshImageStatus"></Poster>
          <div class="poster__footer flex flex1 items-center">
            <!-- <div class="flex1 editor_opinion_btn_wrapper"></div> -->
            <div class="flex1 editor_opinion_btn_wrapper">
              <button
                class="qrcode_handle_btn save-btn"
                @click="editorPreview"
              >
                预览
              </button>
              <button
                class="qrcode_handle_btn save-btn"
                @click="onSave"
              >
                保存
              </button>
            </div>
          </div>
        </div>
        <div class="template__list">
          <TemplateList></TemplateList>
        </div>
      </div>
    </div>

    <EditorPreview></EditorPreview>
  </div>
</template>
<script>
import EditorContent from '@/components/editor/EditorContent'
import EditorHeader from '@/components/editor/EditorHeader'
import Poster from '@/components/editor/Poster'
import TemplateList from '@/components/editor/TemplateList'
import EditorPreview from '@/components/editor/EditorPreview'
import { mapMutations, mapState, mapGetters } from 'vuex'

export default {
  name: 'Editor',
  components: {
    EditorContent,
    EditorHeader,
    Poster,
    TemplateList,
    EditorPreview,
  },
  filters: {},
  directives: {},
  mixins: [],
  props: {},
  data() {
    return {
      title: '',
      // 点击保存，刷新二维码图片标识
      previewVisibleProp: false,
    }
  },
  computed: {
    ...mapState('editor', {
      posterTitle: state => state.posterTitle,
      QRCodeID: state => state.QRCodeID,
      QRCodeFile: state => state.QRCodeFile,
      PosterData: state => state.posterData,
      templateName: state => state.templateName,
    }),
  },
  watch: {},
  created() {},
  mounted() {},
  destroyed() {
    // 为了保证第二次点击进去，根据二维码标题刷新二维码图片
    this.setPosterTitle('')
  },
  methods: {
    ...mapMutations('editor', ['setPosterTitle', 'setShowPreviewStatus', 'setQrcodeImageRefresh']),
    ...mapGetters('editor', ['getQrcodeId', 'getQrcodeType']),
    /*
     * 点击保存按钮
     * */
    async onSave() {
      if (!this.posterTitle || this.posterTitle === '输入自定义标题') {
        this.$message({
          type: 'warning',
          message: '请填写二维码标题',
        })
        return
      }
      this.setQrcodeImageRefresh(true)
    },
    /**
     * 提交保存二维码
     * */
    async commitQrcodeDetail() {
      const htmlData = this.$refs.Editor.editor.txt.html()
      const htmlDataBlob = new Blob([htmlData], { type: 'text/html' })
      const qrcodeFromData = {}
      qrcodeFromData.posterData = this.PosterData
      qrcodeFromData.templateName = this.templateName
      const qrcodeFromDataBlob = new Blob([JSON.stringify(qrcodeFromData)], { type: 'text/html' })
      const qrcodeInfo = {
        ID: this.getQrcodeId(),
        Name: this.posterTitle,
        EntityClassName: 'ModelSetVersionDocument',
        EntityValue: '',
        Type: this.getQrcodeType(),
      }
      const formData = new FormData()
      formData.append('QrcodeInfo', JSON.stringify(qrcodeInfo))
      formData.append('PosterFile', this.QRCodeFile)
      formData.append('HtmlFile', htmlDataBlob)
      formData.append('FormDataFile', qrcodeFromDataBlob)
      const { success } = await this.$http({
        url: this.$api.saveAndUpdateQRCodeInfo,
        method: 'post',
        data: formData,
      })
      if (success) {
        this.setQrcodeImageRefresh(false)
      }
      this.$message({
        type: success ? 'success' : 'error',
        message: success ? '保存成功！' : '保存失败！',
      })
    },
    /**
     * 改变title的钩子
     * @param title
     */
    onTitleChange(title) {
      this.setPosterTitle(title)
    },
    /**
     * title输入框失焦钩子
     */
    onTitleBlur(e) {
      this.setPosterTitle(e.target.value)
    },
    /*
     * 点击预览按钮
     * */
    editorPreview() {
      this.setShowPreviewStatus(true)
    },
    /*
     *监听二维码海报生成
     * */
    refreshImageStatus(status) {
      if (status === 'done') {
        this.commitQrcodeDetail()
      }
    },
  },
}
</script>
<style lang="scss" scoped>
$headerHeight: 67px;
$headerMargin: 11px;

.editor-component {
  height: calc(100% - 64px - 1em);
}

#editor {
  width: calc(100vw);
  background: #ffffff;
  height: calc(100vh);
  overflow: hidden;
  border-radius: 4px;
  .container {
    margin: 11px auto 0;
    padding-left: 5em;

    .container__editor {
      width: 600px;
      height: calc(100vh - #{$headerHeight} - #{$headerMargin});
      background: #ffffff;
      border: 1px solid #dcdcdc;
      box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
      padding: 1em;
      .title-wrapper {
        margin-bottom: 16px;
        ::v-deep .el-input__inner {
          border-radius: 0;
          background-color: #f5f5f5;
          text-align: center;
          color: #222222;
          font-size: 14px;
          font-weight: 400;
          padding: 0 18px;
          height: 42px;
        }
        ::v-deep .el-input__inner::placeholder {
          color: #222222;
        }
      }
    }
    .container__template {
      //width: 420px;
      width: 418px;
      margin-left: 1em;

      .template__posters {
        margin-bottom: 1em;
        border: 1px solid #dcdcdc;
      }

      .template__list {
        margin: 0 -0.5em 0;
      }
    }
    .poster__footer {
      opacity: 1;
      background: #ffffff;
      height: 54px;
      padding: 0 1em;
      border-top: 1px solid #dcdcdc;

      .editor_opinion_btn_wrapper {
        display: flex;
        justify-content: space-between;

        .save-btn {
          border-radius: 0;
          min-width: 90px;
          height: 36px;
        }
      }
    }
  }
}
</style>
<style lang=""></style>
